import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import colimage from '../../../assets/images/colimage.png';

const WhyAriha = () => (
  <Container className='cards my-5 py-5'>
    <Row>
      <Col xs={12} md={7}>
        <img src={colimage} alt="colimage" style={{ width: '100%' }} />
      </Col>
      <Col xs={12} md={5} className='d-flex flex-column align-items-start justify-content-center'>
        <p className='mb-3 text-start fs-2 '>Why Ariha?</p>
        <ul className='list-unstyled'>
          <li className="mb-3">
            <div className="d-flex align-items-center mb-1">
              <span className="me-3 d-flex justify-content-center align-items-center"
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#FBF503",
                  color: "black",
                  fontSize: "14px"
                }}>
                <i className="fas fa-check"></i>
              </span>
              <span className="fs-5 queshead">Freshly Baked Everyday</span>
            </div>
            <p className="mb-0 ms-5 quespara">Made in small batches for uncompromised quality.</p>
          </li>
          <li className="mb-3">
            <div className="d-flex align-items-center mb-1">
              <span className="me-3 d-flex justify-content-center align-items-center"
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#FBF503",
                  color: "black",
                  fontSize: "14px"
                }}>
                <i className="fas fa-check"></i>
              </span>
              <span className="fs-5 queshead">Clean Ingredients</span>
            </div>
            <p className="mb-0 ms-5 quespara">No preservatives, just wholesome goodness.</p>
          </li>
          <li className="mb-3">
            <div className="d-flex align-items-center mb-1">
              <span className="me-3 d-flex justify-content-center align-items-center"
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#FBF503",
                  color: "black",
                  fontSize: "14px"
                }}>
                <i className="fas fa-check"></i>
              </span>
              <span className="fs-5 queshead">Wide Variety</span>
            </div>
            <p className="mb-0 ms-5 quespara">From sweet treats to healthy loaves.</p>
          </li>
          <li className="mb-3">
            <div className="d-flex align-items-center mb-1">
              <span className="me-3 d-flex justify-content-center align-items-center"
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#FBF503",
                  color: "black",
                  fontSize: "14px"
                }}>
                <i className="fas fa-check"></i>
              </span>
              <span className="fs-5 queshead">Trusted by Thousands</span>
            </div>
            <p className="mb-0 ms-5 quespara">Supplying to homes, cafes, and kitchens nationwide.</p>
          </li>
        </ul>
        <Link to="/shop">
          <button className="shop-now-button">
            Shop Now <span className="arrow">→</span>
          </button>
        </Link>
      </Col>
    </Row>
  </Container>
);

export default WhyAriha;